import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeadingSort from '@/components/ui/page-heading-sort/PageHeadingSort';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

export interface IAudioknigi {
  books: IBookPage;
  sortingName: string;
  sortingUrl?: string | undefined;
}

const Audioknigi: FC<IAudioknigi> = ({ books, sortingName, sortingUrl }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = 'Слушать Аудиокниги онлайн бесплатно и без регистрации или скачать бесплатно в mp3';
  const SEO_DESCRIPTION = 'Слушать Аудиокниги онлайн бесплатно и без регистрации или скачать бесплатно в mp3 на КучаКниг.';
  const SEO_CANONICAL = '/audioknigi/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Аудиокниги" />

      <SectionTitleMenu extraClassName={'sectionTitleMenu_sort'}>
        <PageHeadingSort titleName="Аудиокниги" sortingName={sortingName} url="/audioknigi/" extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {books.data && books.data.length ? (
          books.data.map((book: IBooksPageData) => <BookCardItem alias={book.alias} createdAt={book.created_at} author={book.author} book={book.book} rating={book.rating} key={book.id} draft={book.draft} retelling={!!book.retaling} />)
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      {sortingUrl ? <Pagination pagesCount={pagesCount ?? 0} postName={`audioknigi/${sortingUrl}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="audioknigi/page=" />}
      {/* <Breadcrumbs pageName="Аудиокниги" isBottom={true} /> */}
    </Layout>
  );
};

export default Audioknigi;
